import React from 'react'
import * as media from '../../../../media'
import styled from 'styled-components'
import Mobile from "./Mobile";
import Desktop from "./Desktop";

const BiggerThan1000Check = styled.div`
  ${media.smallerThan(600)`display:none;`}
`

const LessThan1000Check = styled.div`
text-align: center;
  ${media.biggerThan(601)`display:none;`}
`

function Why(props) {
  return (
    <div>
      <BiggerThan1000Check>
        <Desktop {...props} />
      </BiggerThan1000Check>
      <LessThan1000Check>
        <Mobile {...props} />
      </LessThan1000Check>
    </div>
  )
}

export default Why;


// WEBPACK FOOTER //
// ./src/finwhale/common/item/why/index.js